import * as React from "react";
import * as _ from "lodash";
import * as queryString from "query-string";
import {ChildrenType} from "../_definitions/styleteq";
import * as reactStringReplace from "react-string-replace";
import {classToPlain, plainToClass} from "class-transformer";
import User from "../_data/models/User";
import * as pluralize from "pluralize";
import Model from "../_data/models/Model";
import Style from "../_data/models/Style";
import Shop from "../_data/models/Shop";
import Special from "../_data/models/Special";
import Booth from "../_data/models/Booth";
import * as alertify from "alertify.js";
import {Map, OrderedMap, Record} from "immutable";
import {ResourceType} from "./data";
import * as $ from "jquery";
import Class = Record.Class;

export function strict_join(array: any[], separator = ' '): string {
    return _.without(array, ['']).join(separator);
}

export function to_url(...array): string {
    return strict_join(array, '/');
}

export function createQueryParameters(parameters: {}, prefixed: boolean = true) {
    return (prefixed ? '?' : '') + queryString.stringify(_.pickBy(parameters, _.identity), {arrayFormat: 'bracket'});

}

export function formatWithTags(text: string): ChildrenType {
    return reactStringReplace(text, new RegExp(/#(\w+)/g), (match, i) => (
        <span className="tag" key={i}> #{match}</span>
    ));
};

export function getCurrentUser(): User {
    if (window.Styleteq.currentUser)
        return plainToClass(User, window.Styleteq.currentUser);
    return null;
}

export function currentUserIsLoggedIn(): boolean {
    return window.Styleteq.currentUser != null;
}

export function prettyPrintLike(likable: Likable) {
    return `${likable.likeCount} ${pluralize("Like", likable.likeCount)}`;
}

export function prettyPrintComment(commentable: Commentable) {
    return `${commentable.commentCount} ${pluralize("Comment", commentable.commentCount)}`;
}

export function prettyPrintFollower(count: number) {
    return `${pluralize("Follower", count)}`;
}

export function apiModelName(model: Model) {
    if (model instanceof Style)
        return 'style';
    else if (model instanceof Shop)
        return 'salon';
    else if (model instanceof Special)
        return 'special';
    else if (model instanceof Booth)
        return 'booth';
    else if (model instanceof User)
        return 'user';
    else
        return null;
}

export function clientModelName(model: Model) {
    if (model instanceof Style)
        return 'style';
    else if (model instanceof Shop)
        return 'shop';
    else if (model instanceof Special)
        return 'special';
    else if (model instanceof Booth)
        return 'booth';
    else if (model instanceof User)
        return 'user';
    else
        return null;
}

export function apiModelNameToClientModelName(modelName: string) {
    switch (modelName) {
        case 'salon':
            return 'shop';
        case 'Salon':
            return 'Shop';
        default:
            return modelName;
    }
}

export function apiModelNameToDisplayName(modelName: string) {
    switch (modelName) {
        case 'salon':
            return 'shop';
        case 'Salon':
            return 'Shop';
        case 'style':
            return 'image';
        case 'Style':
            return 'Image';
        default:
            return modelName;
    }
}

export function properNameToRealModelName(properName: string) {
    switch (properName) {
        case 'shop':
            return 'salon';
        case 'Shop':
            return 'Salon';
        case 'image':
            return 'style';
        case 'Image':
            return 'Style';
        default:
            return properName;
    }
}

export function toast(message: string, position: string = "bottom right") {
    alertify.logPosition(position);
    alertify.log(message);
}

export function toastSuccess(message: string, position: string = "bottom right") {
    alertify.logPosition(position);
    alertify.success(message);
}

export function toastError(message: string, position: string = "bottom right") {
    alertify.logPosition(position);
    alertify.error(message);
}

export function formatDate(date: Date): string {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]}, ${date.getDate()} ${date.getFullYear()}`;
}

export function formatDateTime(date: Date): string {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}  ${date.toLocaleTimeString()}`;
}

export function userReference(resource: string) {
    switch (resource) {
        case ResourceType.shop:
            return 'owner';
        case ResourceType.booth:
            return 'salon.owner';
        case ResourceType.special:
        case ResourceType.style:
            return 'user';
        case ResourceType.conversation:
            return 'user1';
        case ResourceType.message:
            return 'sender';
        default:
            return null;
    }
}

export function getOwnerFromModel(model: Model): User {
    return plainToClass(User, _.get(classToPlain(model), userReference(apiModelName(model))));
}

export function collectionToKeyValue(collection: any) {
    return collection.map((i) => {
        return [i.id, i];
    });
}

export function getLocation(successCallback: PositionCallback, errorCallback: PositionErrorCallback = null) {
    if (navigator.geolocation) {
        return navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    } else {
        toastError("Geolocation is not supported by this browser.");
        return null;
    }
};

export function getSiteUrl(): string {
    let strArr = window.location.href.split('/');
    return strArr[0] + '//' + strArr[2];
}

export function createOrderedMapfromIDs<T>(idsArr: number[], map: Map<number, T>) {
    let x = OrderedMap<number, T>();

    let arr = [];
    idsArr.forEach((value) => {
        arr.push(_.chain(map.get(value)).cloneDeep().value());
    });
    const _map = arr.map((i, index) => {
        return [index, i]
    });

    return x.mergeDeep(OrderedMap<number, T>(_map));
}


export function toggleBodyScroll(show: boolean) {
    $('body').css('overflow-y', show ? 'auto' : 'hidden');
}



// WEBPACK FOOTER //
// ./app/client/_helpers/utils.tsx